import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatPendingStat, usePendingParticipants } from "./hooks/usePendingParticipants";

export const PendingParticipantsView = () => {
  const {
    pending,
    loading,
    error,
    playerOptions,
    selectedPlayerByPending,
    selectPlayer,
    busyId,
    handleAssign,
    handleDismiss,
  } = usePendingParticipants();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack spacing={2} sx={{ py: 2 }}>
      <Typography variant="h5" fontWeight="bold">
        Tunnistamattomat pelaajat
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Nämä Riot-pelin osallistujat eivät täsmänneet rosteriin. Liitä pelaaja tai hylkää rivi.
      </Typography>

      {error ? <Alert severity="error">{error}</Alert> : null}

      {pending.length === 0 ? (
        <Alert severity="success">Ei odottavia osallistujia.</Alert>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Peli</TableCell>
              <TableCell>Riot-nimi</TableCell>
              <TableCell>Champ</TableCell>
              <TableCell>K/D/A</TableCell>
              <TableCell>Joukkue</TableCell>
              <TableCell>Tulos</TableCell>
              <TableCell>Pelaaja</TableCell>
              <TableCell align="right">Toiminnot</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pending.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  #{row.riotGameId}
                  <br />
                  <Typography variant="caption" color="text.secondary">
                    ottelu {row.matchId}
                  </Typography>
                </TableCell>
                <TableCell>{row.riotSummonerName ?? row.riotPuuid.slice(0, 12) + "…"}</TableCell>
                <TableCell>{row.champion ?? "—"}</TableCell>
                <TableCell>
                  {formatPendingStat(row.kills)}/{formatPendingStat(row.deaths)}/
                  {formatPendingStat(row.assists)}
                </TableCell>
                <TableCell>{row.inferredTeamId ?? "—"}</TableCell>
                <TableCell>{row.result === "WIN" ? "V" : "H"}</TableCell>
                <TableCell sx={{ minWidth: 220 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id={`player-${String(row.id)}`}>Pelaaja</InputLabel>
                    <Select
                      labelId={`player-${String(row.id)}`}
                      label="Pelaaja"
                      value={selectedPlayerByPending[row.id] ?? ""}
                      onChange={(e) => {
                        selectPlayer(row.id, e.target.value);
                      }}
                    >
                      {playerOptions.map((player) => (
                        <MenuItem key={player.id} value={player.id}>
                          {player.teamId} · {player.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell align="right">
                  <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button
                      size="small"
                      variant="contained"
                      disabled={!selectedPlayerByPending[row.id] || busyId === row.id}
                      onClick={() => void handleAssign(row.id)}
                    >
                      Liitä
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="inherit"
                      disabled={busyId === row.id}
                      onClick={() => void handleDismiss(row.id)}
                    >
                      Hylkää
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Stack>
  );
};
